import React from 'react';
import { ConfigProvider } from '@ntuctech/tangram-web';
import { useRouter } from 'next/router';

import ContentBlock from '../components/ContentBlock';
import HocAuthenticate from '../components/HocAuthenticate';
import Layout from '../components/Layout';
import MyInfoDetails from '../components/MyInfo/MyInfoDetails';
import MyinfoFloatingError from '../components/MyInfo/MyinfoFloatingError';
import PageContent from '../components/PageContent';
import PageContextProvider from '../components/PageContextProvider';
import PageTitle from '../components/PageTitle';
import Profile from '../components/Profile';
import ProfileVerificationBanner from '../components/Profile/ProfileVerificationBanner';
import ProfileTasks from '../components/ProfileTasks';
import AccountContainer from '../containers/Account';
import { ampVertical, eventNames } from '../services/event-tracking/events';
import { track } from '../services/event-tracking/services';
import { fpThemeTangramNextConfig } from '../services/utils/tangramNextConfig';

const TaskAndProfile = ({ isPersonaEnabled }) => {
  const router = useRouter();
  const showMyinfoError = router.query.myinfoCallbackError;

  return (
    <>
      {showMyinfoError === 'true' && <MyinfoFloatingError />}
      <ProfileVerificationBanner />
      <ProfileTasks />
      <ContentBlock>
        <PageTitle>Profile</PageTitle>
        <PageContent>
          <Profile isPersonaEnabled={isPersonaEnabled} />
        </PageContent>
      </ContentBlock>
      <MyInfoDetails isPersonaEnabled={isPersonaEnabled} />
    </>
  );
};

const PageIndex = (props) => {
  const { fetchUserProfile, userData, authLoading, isPersonaEnabled } = props;

  React.useEffect(() => {
    const eventName = eventNames.SAM_PROFILE_PAGE_VIEWED;
    const trackingProps = {
      user: userData,
      dataLayer: window.dataLayer,
      backTo: window.backTo,
      vertical: ampVertical.ACCOUNT,
    };
    track(eventName, trackingProps);
  }, [userData]);

  return (
    <ConfigProvider
      tokens={fpThemeTangramNextConfig}
      experimental={{
        Text: true,
        Link: true,
        Button: true,
        IconButton: true,
        NotificationBanner: true,
        Tooltip: true,
      }}
    >
      <AccountContainer user={userData} loading={authLoading} refreshUserData={fetchUserProfile}>
        <Layout>
          <PageContextProvider>
            <TaskAndProfile isPersonaEnabled={isPersonaEnabled} />
          </PageContextProvider>
        </Layout>
      </AccountContainer>
    </ConfigProvider>
  );
};

export default HocAuthenticate(PageIndex);
